<template>

  <tr :class="propertyName+idx">
    <td>
      <div class="dvResolve-label">
        <span class="icon-content_project"></span>
        <div class="dvResolve-label-text">{{ propertyName.replace(/_/g, ' ') }}</div>
      </div>
    </td>

    <td v-for="(value, index) in proj" :key="index">{{ value }}</td>
  </tr>

</template>

<script>
  export default {
    name: 'project-info',
    props: ['proj', 'propertyName', 'idx'],
    data: () => ({
    }),
    methods: {
    },
    mounted() {
    }
  }
</script>
